<style>
.menu-opened body:before {
  display: none;
}

@media only screen and (max-width: 850px) {
  .authendication-pages .content .wrapper header img {
    height: 2.308rem !important;
    max-width: 180px !important;
  }
}
</style>
<template>
  <div class="main-wrapper authendication-pages">
    <div class="content">
      <div class="container wrapper no-padding">
        <div class="row no-margin vph-100">
          <div class="col-12 col-sm-12 col-md-12 col-lg-6 no-padding">
            <div class="banner-bg register">
              <div class="row no-margin h-100">
                <div class="col-sm-10 col-md-10 col-lg-10 mx-auto">
                  <div
                    class="h-100 d-flex justify-content-center align-items-center"
                  >
                    <div class="text-bg register text-center">
                      <button
                        type="button"
                        class="btn btn-limegreen text-capitalize"
                      >
                        <i class="fa-solid fa-thumbs-up me-3"></i>Đăng ký ngay
                      </button>
                      <p>
                        Hãy đăng ký ngay để tham gia vào các giải đấu, quản lý
                        thông tin và thứ hạng của mình
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-6 no-padding">
            <div class="dull-pg">
              <div
                class="row no-margin vph-100 d-flex align-items-center justify-content-center"
              >
                <div class="col-sm-10 col-md-10 col-lg-10 mx-auto">
                  <header class="text-center">
                    <router-link to="/trang-chu">
                      <img
                      style="max-width: 400px;"
                        src="@/assets/img/logo_red.png"
                        class="img-fluid"
                        alt="Logo"
                      />
                    </router-link>
                  </header>
                  <div class="shadow-card">
                    <h2>Tham gia với EZ Badminton</h2>
                    <p>Cung cấp thông tin của bạn và bắt đầu ngay bây giờ</p>

                    <div class="tab-content" id="myTabContent">
                      <div
                        class="tab-pane fade show active"
                        id="user"
                        role="tabpanel"
                        aria-labelledby="user-tab"
                      >
                        <!-- Register Form -->
                        <Form
                          @submit="onSubmit"
                          :validation-schema="schema"
                          v-slot="{ errors }"
                        >
                          <!-- First Name -->
                          <div class="form-group">
                            <div class="group-img">
                              <i class="feather-user"></i>
                              <Field
                                name="first_name"
                                type="text"
                                class="form-control"
                                placeholder="Nhập Họ"
                                :class="{ 'is-invalid': errors.first_name }"
                              />
                              <div class="invalid-feedback">
                                {{ errors.first_name }}
                              </div>
                            </div>
                          </div>

                          <!-- Middle Name -->
                          <div class="form-group">
                            <div class="group-img">
                              <i class="feather-user"></i>
                              <Field
                                name="middle_name"
                                type="text"
                                class="form-control"
                                placeholder="Nhập tên đệm"
                              />
                            </div>
                          </div>

                          <!-- Last Name -->
                          <div class="form-group">
                            <div class="group-img">
                              <i class="feather-user"></i>
                              <Field
                                name="last_name"
                                type="text"
                                class="form-control"
                                placeholder="Nhập tên"
                                :class="{ 'is-invalid': errors.last_name }"
                              />
                              <div class="invalid-feedback">
                                {{ errors.last_name }}
                              </div>
                            </div>
                          </div>

                          <!-- Email -->
                          <div class="form-group">
                            <div class="group-img">
                              <i class="feather-mail"></i>
                              <Field
                                name="email"
                                type="email"
                                class="form-control"
                                placeholder="Email"
                                :class="{ 'is-invalid': errors.email }"
                              />
                              <div class="invalid-feedback">
                                {{ errors.email }}
                              </div>
                            </div>
                          </div>

                          <!-- Password -->
                          <div class="form-group">
                            <div class="pass-group group-img">
                              <Field
                                name="password"
                                :type="showPassword ? 'text' : 'password'"
                                class="form-control pass-input mt-2"
                                placeholder="Mật khẩu"
                                :class="{ 'is-invalid': errors.password }"
                              />

                              <span @click="toggleShow" class="toggle-password">
                                <i
                                  :class="
                                    showPassword
                                      ? 'fas fa-eye'
                                      : 'fas fa-eye-slash'
                                  "
                                ></i>
                              </span>
                              <div class="invalid-feedback">
                                {{ errors.password }}
                              </div>
                            </div>
                          </div>

                          <!-- Confirm Password -->
                          <div class="form-group">
                            <div class="pass-group group-img">
                              <Field
                                name="confirm_password"
                                :type="showPassword1 ? 'text' : 'password'"
                                class="form-control pass-input mt-2"
                                placeholder="Xác nhận mật khẩu"
                                :class="{
                                  'is-invalid': errors.confirm_password,
                                }"
                              />
                              <span
                                @click="toggleShow1"
                                class="toggle-password"
                              >
                                <i
                                  :class="{
                                    'fas fa-eye': showPassword1,
                                    'fas fa-eye-slash': !showPassword1,
                                  }"
                                ></i>
                              </span>
                              <div class="invalid-feedback" >
                                {{ errors.confirm_password }}
                              </div>
                            </div>
                          </div>

                          <!-- Terms & Conditions -->
                          <div
                            class="form-check d-flex justify-content-start align-items-center policy"
                          >
                            <div class="d-inline-block">
                              <Field
                                class="form-check-input"
                                type="checkbox"
                                name="policy"
                                id="policy"
                              />
                            </div>

                            <label class="form-check-label" for="policy"
                              >Để tiếp tục, hãy cho biết rằng bạn đã đọc và đồng
                              ý với
                              <router-link to="/chinh-sach"
                                >Điều khoản sử dụng</router-link
                              ></label
                            >
                          </div>
                          <div class="invalid-feedback d-block">
                            {{ errors.policy }}
                          </div>

                          <!-- Submit Button -->
                          <button
                            class="btn btn-secondary register-btn d-inline-flex justify-content-center align-items-center w-100 btn-block"
                            type="submit"
                          >
                            Tạo tài khoản<i
                              class="feather-arrow-right-circle ms-2"
                            ></i>
                          </button>

                          <!-- Social Login -->
                          <div class="form-group">
                            <div class="login-options text-center">
                              <span class="text">Hoặc tiếp tục với</span>
                            </div>
                          </div>
                          <div class="form-group mb-0">
                            <ul
                              class="social-login d-flex justify-content-center align-items-center"
                            >
                              <li class="text-center">
                                <button
                                  type="button" @click="loginWithGoogle"
                                  class="btn btn-social d-flex align-items-center justify-content-center"
                                >
                                  <img
                                    src="@/assets/img/icons/google.svg"
                                    class="img-fluid"
                                    alt="Google"
                                  />
                                  <span>Google</span>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </Form>
                        <!-- /Register Form -->
                      </div>
                    </div>
                  </div>
                  <div class="bottom-text text-center">
                    <p>
                      Bạn đã có tài khoản?
                      <router-link to="/login"> Đăng nhập!</router-link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import { Form, Field } from 'vee-validate'
import * as Yup from 'yup'
import { registerPlayer } from '@/api/strapi/player.ts'
import { router } from '@/router'
import userService from "@/stores/user";

const showPassword = ref(false)
const showPassword1 = ref(false)

const loading = ref(false)

const schema = Yup.object({
  first_name: Yup.string().required('Vui lòng nhập Họ'),
  middle_name: Yup.string(),
  last_name: Yup.string().required('Vui lòng nhập Tên'),
  email: Yup.string().required('Vui lòng nhập email').email('Invalid email'),
  password: Yup.string()
      .min(6, 'Mật khẩu phải có ít nhất 6 ký tự')
      .max(50, 'Mật khẩu không được quá 50 ký tự')
      .required('Vui lòng nhập mật khẩu'),
  confirm_password: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Mật khẩu không khớp')
      .required('Vui lòng xác nhận mật khẩu'),
  policy: Yup.mixed().oneOf([true], 'Vui lòng đồng ý với khoản sử dụng'),
})

const onSubmit = async (values) => {
  loading.value = true
  try {
    const response = await registerPlayer(values)
    if (response?.data?.message) {
      alert('Đăng ký tài khoản thành công!')
      router.push('/login')
    }
  } catch (error) {
    const message = error.response?.data?.error?.message
    alert(message || 'Đã có lỗi xảy ra')
  } finally {
    loading.value = false
  }
}

const loginWithGoogle = async () => {
  try {
    const res = await userService.loginGoogle();
    window.location.href = res.data.url;
  } catch (error) {
    console.log(error);
  }
}

const toggleShow = () => {
  showPassword.value = !showPassword.value
}
const toggleShow1 = () => {
  showPassword1.value = !showPassword1.value
}
</script>

